import { type ButtonProps } from '@ui/atoms/button'
import { type LinkProps } from '@ui/atoms/link'
import { type LinkUnstyledProps } from '@ui/link-unstyled'

export enum ENHANCED_COMPONENT_TYPE {
  CTA = 'cta',
  HYPERLINK = 'hyperlink',
}

export enum ENHANCED_COMPONENT_ROLE {
  MAIN = 'cta_principal',
  SECONDARY = 'cta_secondaire',
  MENU_ITEM = 'menu_item',
  STICKY_ACCESS = 'cta_sticky_accès_parcours',
  STICKY_FORM = 'cta_sticky_formulaire',
  MOBILE_FORM = 'cta_mobile_open_form',
  SUBSCRIPTION_FORM = 'cta_subscription_form',
}

export type EnhancedComponentExtendedProps =
  | ButtonProps
  | LinkProps
  | LinkUnstyledProps
